"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = hoc;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _eventEmitter = _interopRequireDefault(require("../Base/views/eventEmitter.c"));

var _dataModel = _interopRequireDefault(require("../../common/backbone/dataModel"));

var _dataCollection = _interopRequireDefault(require("../../common/backbone/dataCollection"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// for event emulation
var preventDefault = function preventDefault() {};

var stopPropagation = function stopPropagation() {};

function hoc(ComponentToWrap) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_EventEmitter) {
    (0, _inherits2["default"])(_class, _EventEmitter);

    function _class(props) {
      var _this;

      (0, _classCallCheck2["default"])(this, _class);
      _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_class).call(this, props));
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_handleChange", function () {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var value = event.target ? _this.props.isCheckbox ? event.target.checked : event.target.value : event;
        _this._lastOnChangeEvent = _objectSpread({}, event);
        _this.__last_updated_value = value;

        _this.setState({
          value: _this._format(value)
        }, function () {
          _this._updateStorage(value);

          _this._dispatchSyntheticEvent();
        });
      });
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_createRef", function (el) {
        var elementRef = _this.props.elementRef;

        if (typeof elementRef === 'function') {
          elementRef(el);
        } else if ((0, _typeof2["default"])(elementRef) === 'object') {
          elementRef.current = el;
        }

        _this.componentRef = el;
      });

      var _value = _this._getValueFromStorage(),
          collection = _this._getCollection(props);

      if (!_value) {
        _value = props.defaultValue || null;
      }

      _this.state = {
        value: _value,
        // DataCollection only, for data-bind
        collection: collection ? collection.models : null
      };

      _this._listenStorage();

      _this._listenCollection(collection);

      return (0, _possibleConstructorReturn2["default"])(_this, (0, _assertThisInitialized2["default"])(_this));
    }

    (0, _createClass2["default"])(_class, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.props.storage instanceof _dataModel["default"]) {
          this.stopListening(this.props.storage);
        }

        var cll = this._getCollection(this.props);

        if (cll instanceof _dataCollection["default"]) {
          this.stopListening(cll);
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;

        var _this$props = this.props,
            storage = _this$props.storage,
            attribute = _this$props.attribute; // storage был удален

        if (prevProps.storage && !storage) {
          this.stopListening(prevProps.storage);
        } // обновились хранилища данныех, необходимо переподписаться на новое
        // и обновить актуальное значение


        if (storage && this._needRebindStorage(storage)) {
          this._rebind(storage, attribute);

          this.setState({
            value: this._getValueFromStorage(storage, attribute)
          }, function () {
            return _this2._dispatchSyntheticEvent();
          });
        }

        var collection = this._getCollection(prevProps),
            newCollection = this._getCollection(this.props); // collection был удален


        if (collection && !newCollection) {
          this.stopListening(collection);
        }

        if (collection !== newCollection) {
          this._rebind(newCollection);

          this.setState({
            collection: newCollection || []
          });
        }

        return this;
      }
      /**
       * определяет необходимость переподписки на storage при изменении props в componentWillReceiveProps
       * @param {object} nextProps
       * @return {boolean|*}
       * @private
       */

    }, {
      key: "_needRebindStorage",
      value: function _needRebindStorage() {
        var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var needRebind = false;

        if (this.props.storage !== nextProps.storage) {
          // we got a new valid Model storage
          if (nextProps.storage instanceof _dataModel["default"]) {
            needRebind = true;
          }
        }

        if (this.props.attribute !== nextProps.attribute) {
          // we got a new valid attribute name
          if (nextProps.attribute) {
            needRebind = true;
          }
        } // или изменился storage|attribute


        return needRebind;
      }
    }, {
      key: "_rebind",
      value: function _rebind(nextStorage, attribute) {
        var isModel = nextStorage instanceof _dataModel["default"],
            isCollection = nextStorage instanceof _dataCollection["default"];

        if (isModel && attribute) {
          this._listenStorage(nextStorage, attribute);
        } else if (isCollection) {
          this._listenCollection(nextStorage);
        }

        return this;
      }
      /**
       * Возвращает текущее значение из модели
       * @param {object} storage
       * @param {string} attribute
       * @return {*}
       */

    }, {
      key: "_getValueFromStorage",
      value: function _getValueFromStorage() {
        var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.storage;
        var attribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.attribute;
        var value = null;

        if (storage instanceof _dataModel["default"] && attribute) {
          value = storage.get(attribute);
          value = value instanceof _dataModel["default"] ? value.id : value;
          value = value === undefined ? null : value;
        }

        return value;
      }
    }, {
      key: "_listenStorage",
      value: function _listenStorage() {
        var _this3 = this;

        var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.storage;
        var attribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.attribute;

        if (storage instanceof _dataModel["default"] && attribute) {
          this.stopListening(storage);
          this.listenTo(storage, "change:".concat(attribute), function () {
            if (_this3.__last_updated_value === undefined || _this3.__last_updated_value !== storage.__data_bind_last_updated_value) {
              _this3.setState({
                value: _this3._getValueFromStorage()
              }, function () {
                return _this3._dispatchSyntheticEvent();
              });
            }

            delete _this3.__last_updated_value;
          });
        }

        return this;
      }
    }, {
      key: "_listenCollection",
      value: function _listenCollection(collection) {
        var _this4 = this;

        if (collection instanceof _dataCollection["default"]) {
          // коллекция тригерит слишком много событий при изменеии чего либо
          this.listenTo(collection, 'all', (0, _debounce["default"])(function () {
            _this4.setState({
              collection: [].concat(collection.models)
            });
          }, 200, {
            leading: true
          }));
          return this;
        }
      }
      /**
       * обновление модели при изменении значения компонента
       * @private
       * @param {*} value
       * @return {object}
       */

    }, {
      key: "_updateStorage",
      value: function _updateStorage() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.value;

        if (this.props.storage instanceof _dataModel["default"] && this.props.attribute) {
          this.props.storage.__data_bind_last_updated_value = value;
          this.props.storage.set(this.props.attribute, value, {
            validate: false
          });
        }

        return this;
      }
    }, {
      key: "_format",
      value: function _format() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        if (typeof this.props.format === 'function') {
          value = this.props.format(value);
        }

        return value;
      }
    }, {
      key: "_toString",
      value: function _toString() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.value;

        if (typeof this.props.stringify === 'function') {
          return this.props.stringify(value);
        }

        if (value === undefined || value === null) {
          value = '';
        } else if (typeof value === 'number') {
          value = String(value);
        }

        return value;
      }
    }, {
      key: "_dispatchSyntheticEvent",
      value: function _dispatchSyntheticEvent() {
        var event;

        if (this._lastOnChangeEvent) {
          event = this._lastOnChangeEvent;
        } else {
          // симулируем событие, когда истоником изменения является модель, а не onChange
          event = {
            target: this.componentRef,
            currentTarget: this.componentRef,
            preventDefault: preventDefault,
            stopPropagation: stopPropagation,
            type: 'change'
          };
        }

        if (typeof this.props.onChange === 'function') {
          this.props.onChange(event);
        }

        delete this._lastOnChangeEvent;
      }
      /**
       * находит коллекцию среди this.props
       * приоритет:
       *      this.props.collection
       *      this.props.storage[attribute].allowedValues
       * @private
       * @param {object} props
       * @return {object}
       */

    }, {
      key: "_getCollection",
      value: function _getCollection() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var collection,
            attribute = props.attribute;

        if (props.collection instanceof _dataCollection["default"] || props.collection instanceof Array) {
          collection = props.collection;
        } else if (props.storage instanceof _dataModel["default"] && attribute && props.storage.fields && props.storage.fields[attribute] && (props.storage.fields[attribute].allowedValues instanceof Array || props.storage.fields[attribute].allowedValues instanceof _dataCollection["default"])) {
          collection = props.storage.fields[attribute].allowedValues;
        }

        return collection;
      }
    }, {
      key: "render",
      value: function render() {
        var props = _objectSpread({}, this.props, {
          onChange: this._handleChange,
          value: this._toString(),
          elementRef: this._createRef,
          name: this.props.name || this.props.attribute
        });

        if (this.state.collection || this.props.collection) {
          // DataCollection || Array
          props.collection = this.state.collection || this.props.collection;
        }

        if (this.props.isCheckbox) {
          props.checked = !!this.state.value;
        }

        if (this.props.isRadio) {
          // оставляем оригинальное значение value
          props.value = this.props.value;
          props.checked = String(this.props.value) === this._toString();
        } // data bind not allow uncontrolled components
        // defaultValue is placeholder of model value


        delete props.defaultValue;
        return _react["default"].createElement(ComponentToWrap, props, this.props.children);
      }
    }]);
    return _class;
  }(_eventEmitter["default"]), (0, _defineProperty2["default"])(_class, "wrappedComp", ComponentToWrap), (0, _defineProperty2["default"])(_class, "propTypes", {
    onValid: _propTypes["default"].func,
    onChange: _propTypes["default"].func,
    elementRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
    stringify: _propTypes["default"].func,
    format: _propTypes["default"].func,
    isCheckbox: _propTypes["default"].bool,
    isRadio: _propTypes["default"].bool,
    collection: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object])
  }), (0, _defineProperty2["default"])(_class, "displayName", 'DataBind(' + (ComponentToWrap.displayName || '') + ')'), _temp;
}